<script>
import { mapGetters } from 'vuex';
import Banner from 'dashboard/components/ui/Banner.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

const STATUS_MESSAGES = {
  freemium_expired:
    'Seu periodo Freemium expirou. Regularize o faturamento para voltar a operar.',
  canceled:
    'O plano da conta foi cancelado. Contrate um plano para voltar a operar.',
  past_due_blocked:
    'O faturamento esta pendente e a operacao da conta foi bloqueada.',
  suspended:
    'A operacao da conta esta suspensa. Acesse o faturamento para revisar o status.',
};

export default {
  name: 'BillingOperationalBanner',
  components: {
    Banner,
  },
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
      summary: 'billingEntitlements/getSummary',
      billingStatus: 'billingEntitlements/getBillingStatus',
    }),
    shouldShowBanner() {
      return !!this.summary?.isOperationallyBlocked;
    },
    bannerMessage() {
      return (
        STATUS_MESSAGES[this.billingStatus] ||
        'A conta precisa regularizar o faturamento para voltar a operar.'
      );
    },
    actionButtonMessage() {
      return 'Ir para faturamento';
    },
    billingPath() {
      return frontendURL(`accounts/${this.currentAccountId}/settings/billing`);
    },
  },
  methods: {
    routeToBilling() {
      this.$router.push(this.billingPath).catch(() => {});
    },
  },
};
</script>

<template>
  <div class="billing-operational-banner shrink-0">
    <Banner
      v-if="shouldShowBanner"
      color-scheme="alert"
      :banner-message="bannerMessage"
      :action-button-label="actionButtonMessage"
      has-action-button
      @click="routeToBilling"
    />
  </div>
</template>
